let productInfoWrapper = document.querySelector('.product__info-container');
let openButtons = document.querySelectorAll('.product__fade-up-details-open-button');

function showDetails(blockId) {
  let details = document.querySelector(
    `.product__fade-up-details-content-wrapper[data-fade-up-details-id="${blockId}"]`
  );
  productInfoWrapper.classList.remove('product__info-container--fade-in');
  details.classList.remove('product__fade-up-details-content-wrapper--fade-down');
  productInfoWrapper.classList.add('product__info-container--details-open');

  details.classList.add(
    'product__fade-up-details-content-wrapper--visible',
    'product__fade-up-details-content-wrapper--fade-up'
  );
  openButtons.forEach((openButton) => {
    openButton.classList.add('hidden');
  });
}

function hideDetails(blockId) {
  let details = document.querySelector(
    `.product__fade-up-details-content-wrapper[data-fade-up-details-id="${blockId}"]`
  );
  let opener = document.getElementById(`product-fade-up-details-${blockId}`);
  details.classList.remove('product__fade-up-details-content-wrapper--fade-up');
  details.classList.add('product__fade-up-details-content-wrapper--fade-down');

  setTimeout(() => {
    productInfoWrapper.classList.remove('product__info-container--details-open');
    productInfoWrapper.classList.add('product__info-container--fade-in');
    details.classList.remove('product__fade-up-details-content-wrapper--visible');
    openButtons.forEach((openButton) => {
      openButton.classList.remove('hidden');
    });
    setTimeout(() => {
      details.classList.remove('product__fade-up-details-content-wrapper--fade-down');
    }, 50);
  }, 100);
}
